window.addEventListener("load", function () {
  var btn = document.querySelector("#lan-ld-26-a-footer .btn__toggle-info");
  var group = document.querySelector("#lan-ld-26-a-footer .group__footer");

  if (btn && group) {
    btn.addEventListener("click", function () {
      btn.classList.toggle("open");
      group.classList.toggle("open");
    });
  }
});
